import React, { useState } from 'react';

const Chatbot = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleChat = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="chatbot-container">
      {/* Bouton du chatbot */}
      <button className="chatbot-button" onClick={toggleChat}>
        <div className="chatbot-icon">
          <span className="chat-icon">💬</span>
        </div>
      </button>

      {/* Fenêtre du chat */}
      {isOpen && (
        <div className="chatbot-window">
          <div className="chatbot-header">
            <h3>Bravo Energy</h3>
            <button className="close-button" onClick={toggleChat}>
              ×
            </button>
          </div>
          <div className="chatbot-content">
            <div className="chat-message">
              <p>Bonjour ! Comment puis-je vous aider aujourd'hui ?</p>
            </div>
            <div className="chat-input">
              <input type="text" placeholder="Tapez votre message..." />
              <button className="send-button">→</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Chatbot; 